import deDE from "./literals/de-DE.json";
import enGB from "./literals/en-GB.json";
import es from "./literals/es.json";
import esMX from "./literals/es-MX.json";
import frFR from "./literals/fr-FR.json";
import itIT from "./literals/it-IT.json";
import nlNL from "./literals/nl-NL.json";

export default {
    "de-DE": deDE,
    "en-GB": enGB,
    "es": es,
    "es-MX": esMX,
    "fr-FR": frFR,
    "it-IT": itIT,
    "nl-NL": nlNL,
}
